export default "__VITE_ASSET__BC7nK3HI__"